module.exports = __webpack_public_path__ + "img/미스틱 (2).83cfd1c6.png";